import { defineMessages } from 'react-intl';
export default defineMessages({
    aboveHorizonAllDay: {
        id: 'astral.aboveHorizonAllDay',
        defaultMessage: 'Above the horizon all day'
    },
    aboveTheHorizon: {
        id: 'astral.aboveTheHorizon',
        defaultMessage: 'above the horizon'
    },
    apparentSize: {
        id: 'astral.apparentSize',
        defaultMessage: 'Apparent size'
    },
    apparentSizeAcross: {
        id: 'astral.apparentSizeAcross',
        defaultMessage: '{size} across'
    },
    astronomicalDawn: {
        id: 'astral.astronomicalDawn',
        defaultMessage: 'Astronomical dawn'
    },
    astronomicalDusk: {
        id: 'astral.astronomicalDusk',
        defaultMessage: 'Astronomical dusk'
    },
    belowHorizonAllDay: {
        id: 'astral.belowHorizonAllDay',
        defaultMessage: 'Below the horizon all day'
    },
    belowHorizonSince: {
        id: 'astral.belowHorizonSince',
        defaultMessage: 'Below the horizon since {time}'
    },
    belowHorizonSinceOn: {
        id: 'astral.belowHorizonSinceOn',
        defaultMessage: 'Below the horizon since {day} {time}'
    },
    brightAllNight: {
        id: 'astral.brightAllNight',
        defaultMessage: 'Bright all night — never fully dark'
    },
    brightestMoment: {
        id: 'astral.brightestMoment',
        defaultMessage: 'Brightest moment'
    },
    civilDawn: {
        id: 'astral.civilDawn',
        defaultMessage: 'Civil dawn'
    },
    civilDusk: {
        id: 'astral.civilDusk',
        defaultMessage: 'Civil dusk'
    },
    darkSkyBetween: {
        id: 'astral.darkSkyBetween',
        defaultMessage: 'Dark sky {from} → {to}'
    },
    darkSkyWindow: {
        id: 'astral.darkSkyWindow',
        defaultMessage: 'Dark sky {from} → {to} · {duration} without the moon'
    },
    dayLength: {
        id: 'astral.dayLength',
        defaultMessage: 'Day length'
    },
    daylightThroughTheYear: {
        id: 'astral.daylightThroughTheYear',
        defaultMessage: 'Daylight through the year'
    },
    dayOfCycle: {
        id: 'astral.dayOfCycle',
        defaultMessage: 'day {day} of {total}'
    },
    doesNotOccurToday: {
        id: 'astral.doesNotOccurToday',
        defaultMessage: 'Does not occur today'
    },
    domeHint: {
        id: 'astral.domeHint',
        defaultMessage: 'Drag to step through the night'
    },
    domeReadout: {
        id: 'astral.domeReadout',
        defaultMessage: '{time} · {altitude} · {direction}'
    },
    earliestSunrise: {
        id: 'astral.earliestSunrise',
        defaultMessage: 'Earliest sunrise'
    },
    earliestSunset: {
        id: 'astral.earliestSunset',
        defaultMessage: 'Earliest sunset'
    },
    equinox: {
        id: 'astral.equinox',
        defaultMessage: 'Equinox'
    },
    equinoxIn: {
        id: 'astral.equinoxIn',
        defaultMessage: 'Equinox in {days, plural, one {# day} other {# days}}'
    },
    evening: {
        id: 'astral.evening',
        defaultMessage: 'Evening'
    },
    exactPhaseAt: {
        id: 'astral.exactPhaseAt',
        defaultMessage: 'Exact at {time}'
    },
    firstQuarter: {
        id: 'astral.firstQuarter',
        defaultMessage: 'First quarter'
    },
    firstSunriseIn: {
        id: 'astral.firstSunriseIn',
        defaultMessage: 'First sunrise in {days, plural, one {# day} other {# days}}'
    },
    firstSunsetIn: {
        id: 'astral.firstSunsetIn',
        defaultMessage: 'First sunset in {days, plural, one {# day} other {# days}}'
    },
    fullMoon: {
        id: 'astral.fullMoon',
        defaultMessage: 'Full moon'
    },
    goldenHourBegins: {
        id: 'astral.goldenHourBegins',
        defaultMessage: 'Golden hour begins'
    },
    goldenHourEnds: {
        id: 'astral.goldenHourEnds',
        defaultMessage: 'Golden hour ends'
    },
    highestPoint: {
        id: 'astral.highestPoint',
        defaultMessage: 'Highest point'
    },
    inDays: {
        id: 'astral.inDays',
        defaultMessage: 'in {days, plural, one {# day} other {# days}}'
    },
    lastQuarter: {
        id: 'astral.lastQuarter',
        defaultMessage: 'Last quarter'
    },
    latestSunrise: {
        id: 'astral.latestSunrise',
        defaultMessage: 'Latest sunrise'
    },
    latestSunset: {
        id: 'astral.latestSunset',
        defaultMessage: 'Latest sunset'
    },
    litShort: {
        id: 'astral.litShort',
        defaultMessage: 'Lit'
    },
    longestDay: {
        id: 'astral.longestDay',
        defaultMessage: 'Longest day'
    },
    lowestPoint: {
        id: 'astral.lowestPoint',
        defaultMessage: 'Lowest point'
    },
    maxAltitudeShort: {
        id: 'astral.maxAltitudeShort',
        defaultMessage: 'Max'
    },
    midday: {
        id: 'astral.midday',
        defaultMessage: 'Midday'
    },
    midnightSun: {
        id: 'astral.midnightSun',
        defaultMessage: 'Midnight sun'
    },
    midnightSunPeriod: {
        id: 'astral.midnightSunPeriod',
        defaultMessage: 'Midnight sun'
    },
    milestoneFootnotePolar: {
        id: 'astral.milestoneFootnotePolar',
        defaultMessage: 'The sun neither rises nor sets on {days, plural, one {# day} other {# days}} of the year here, so in place of the usual sunrise and sunset extremes the list shows when that happens.'
    },
    milestoneFootnoteTemperate: {
        id: 'astral.milestoneFootnoteTemperate',
        defaultMessage: 'The earliest sunset and the latest sunrise do not fall on the shortest day — the equation of time, not the solstice, sets those two dates.'
    },
    moon: {
        id: 'astral.moon',
        defaultMessage: 'Moon'
    },
    moonAltitude: {
        id: 'astral.moonAltitude',
        defaultMessage: 'Altitude'
    },
    moonDirection: {
        id: 'astral.moonDirection',
        defaultMessage: 'Azimuth'
    },
    moonDistance: {
        id: 'astral.moonDistance',
        defaultMessage: 'Distance'
    },
    moonlessFor: {
        id: 'astral.moonlessFor',
        defaultMessage: '{duration} moonless'
    },
    moonPhases: {
        id: 'astral.moonPhases',
        defaultMessage: 'Moon phases'
    },
    moonrise: {
        id: 'astral.moonrise',
        defaultMessage: 'Moonrise'
    },
    moonset: {
        id: 'astral.moonset',
        defaultMessage: 'Moonset'
    },
    moonUpAllNight: {
        id: 'astral.moonUpAllNight',
        defaultMessage: 'The moon is up all night'
    },
    moonWashesOutNight: {
        id: 'astral.moonWashesOutNight',
        defaultMessage: 'The moon is up from {rise} to {set} and washes out the whole night'
    },
    morning: {
        id: 'astral.morning',
        defaultMessage: 'Morning'
    },
    nauticalDawn: {
        id: 'astral.nauticalDawn',
        defaultMessage: 'Nautical dawn'
    },
    nauticalDusk: {
        id: 'astral.nauticalDusk',
        defaultMessage: 'Nautical dusk'
    },
    newMoon: {
        id: 'astral.newMoon',
        defaultMessage: 'New moon'
    },
    nextDay: {
        id: 'astral.nextDay',
        defaultMessage: '+1 day'
    },
    nextProperlyDarkNight: {
        id: 'astral.nextProperlyDarkNight',
        defaultMessage: 'Next properly dark night'
    },
    nextRise: {
        id: 'astral.nextRise',
        defaultMessage: 'next rise {time}'
    },
    nextRiseOn: {
        id: 'astral.nextRiseOn',
        defaultMessage: 'next rise {day} {time}'
    },
    nextSevenNights: {
        id: 'astral.nextSevenNights',
        defaultMessage: 'Next seven nights'
    },
    noAstronomicalDarknessTonight: {
        id: 'astral.noAstronomicalDarknessTonight',
        defaultMessage: 'No astronomical darkness tonight'
    },
    nightDate: {
        id: 'astral.nightDate',
        defaultMessage: 'Date'
    },
    noDarkNightAhead: {
        id: 'astral.noDarkNightAhead',
        defaultMessage: 'None in the next two weeks'
    },
    noStationLocation: {
        id: 'astral.noStationLocation',
        defaultMessage: 'Location unknown'
    },
    noStationLocationDescription: {
        id: 'astral.noStationLocationDescription',
        defaultMessage: 'This station has no position on record, so the sun and moon cannot be calculated for it.'
    },
    noSunriseToday: {
        id: 'astral.noSunriseToday',
        defaultMessage: 'No sunrise today'
    },
    nowAtBearing: {
        id: 'astral.nowAtBearing',
        defaultMessage: 'now {altitude} · azimuth {direction}'
    },
    observing: {
        id: 'astral.observing',
        defaultMessage: 'Observing'
    },
    ofDaylightLeft: {
        id: 'astral.ofDaylightLeft',
        defaultMessage: 'of daylight left'
    },
    overTheNextThreeWeeks: {
        id: 'astral.overTheNextThreeWeeks',
        defaultMessage: 'over the next 3 weeks'
    },
    percentLit: {
        id: 'astral.percentLit',
        defaultMessage: '{percent} lit'
    },
    polarNight: {
        id: 'astral.polarNight',
        defaultMessage: 'Polar night'
    },
    polarNightPeriod: {
        id: 'astral.polarNightPeriod',
        defaultMessage: 'Polar night'
    },
    rightNow: {
        id: 'astral.rightNow',
        defaultMessage: 'Right now'
    },
    riseShort: {
        id: 'astral.riseShort',
        defaultMessage: 'Rise'
    },
    setShort: {
        id: 'astral.setShort',
        defaultMessage: 'Set'
    },
    shortestDay: {
        id: 'astral.shortestDay',
        defaultMessage: 'Shortest day'
    },
    solarNoon: {
        id: 'astral.solarNoon',
        defaultMessage: 'Solar noon'
    },
    solstice: {
        id: 'astral.solstice',
        defaultMessage: 'Solstice'
    },
    sunBelowHorizon: {
        id: 'astral.sunBelowHorizon',
        defaultMessage: 'Sun {degrees}° below the horizon'
    },
    sunEvents: {
        id: 'astral.sunEvents',
        defaultMessage: 'Sun events'
    },
    sunNeverDarkEnough: {
        id: 'astral.sunNeverDarkEnough',
        defaultMessage: 'The sun never gets 18° below the horizon'
    },
    sunNeverSets: {
        id: 'astral.sunNeverSets',
        defaultMessage: 'Sun never sets'
    },
    sunrise: {
        id: 'astral.sunrise',
        defaultMessage: 'Sunrise'
    },
    sunriseAndSunset: {
        id: 'astral.sunriseAndSunset',
        defaultMessage: 'Sunrise and sunset'
    },
    sunriseAt: {
        id: 'astral.sunriseAt',
        defaultMessage: 'Sunrise at {time}'
    },
    sunset: {
        id: 'astral.sunset',
        defaultMessage: 'Sunset'
    },
    sunsetAt: {
        id: 'astral.sunsetAt',
        defaultMessage: 'Sunset at {time}'
    },
    thisYearAtNorth: {
        id: 'astral.thisYearAtNorth',
        defaultMessage: 'This year at {degrees}°N'
    },
    thisYearAtSouth: {
        id: 'astral.thisYearAtSouth',
        defaultMessage: 'This year at {degrees}°S'
    },
    tonight: {
        id: 'astral.tonight',
        defaultMessage: 'Tonight'
    },
    twilightAllNight: {
        id: 'astral.twilightAllNight',
        defaultMessage: 'Twilight all night — never fully dark'
    },
    upFor: {
        id: 'astral.upFor',
        defaultMessage: 'Up for {duration}'
    },
    usableLight: {
        id: 'astral.usableLight',
        defaultMessage: 'Usable light'
    },
    vsAverage: {
        id: 'astral.vsAverage',
        defaultMessage: '{percent} vs average'
    },
    vsYesterday: {
        id: 'astral.vsYesterday',
        defaultMessage: 'vs yesterday'
    },
    waningCrescent: {
        id: 'astral.waningCrescent',
        defaultMessage: 'Waning crescent'
    },
    waningGibbous: {
        id: 'astral.waningGibbous',
        defaultMessage: 'Waning gibbous'
    },
    waxingCrescent: {
        id: 'astral.waxingCrescent',
        defaultMessage: 'Waxing crescent'
    },
    waxingGibbous: {
        id: 'astral.waxingGibbous',
        defaultMessage: 'Waxing gibbous'
    },
    whereToLook: {
        id: 'astral.whereToLook',
        defaultMessage: 'Where to look'
    },
    withoutTheMoon: {
        id: 'astral.withoutTheMoon',
        defaultMessage: '{duration} without the moon'
    }
});
